import { MiniAsset } from '@fullyops/data/assets/asset';

export function mapAssetToOption(e: MiniAsset): {
  id: string;
  name: string;
} {
  return {
    id: e.id,
    name:
      e.serialNumber != null && e.serialNumber !== ''
        ? `[${e.serialNumber}] ${e.name}`
        : e.name,
  };
}
